// empty :: a -> Boolean
const empty = (x) => !!x;

export { empty };
